/* Program Name: CustomThemeContext.js
 **  Description: a component that handles the state of the theme for the
 **               entire application
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-04-12  STT  Initial program
 *********************************************************************************/

/**React imports */
import React, { useContext, createContext, useState, useEffect } from 'react'

/**MUI imports */
import { createTheme, ThemeProvider } from '@mui/material/styles'

/** Context imports */
import { useDomain } from './DomainContext'
import { getTheme } from '../Components/Common/Layout/LayoutAPI'

//Creates the AlertContext using reacts context //DOCS: https://reactjs.org/docs/context.html
const CustomThemeContext = createContext()

//Creates the hook to access the state of the AlertContext //DOCS: https://reactjs.org/docs/hooks-custom.html
export function useCustomTheme() {
  return useContext(CustomThemeContext)
}

/**Constructor for the AlertProvider component */
//children > props that passes the components through it like a wrapper
export default function CustomThemeProvider({ children }) {
  /*********************************************************************************************** */
  /**Local Variables */

  const { strippedDomain } = useDomain()
  //alert holds the status of the alerts 'success' and 'fail'
  //false = closed, true = open
  const [currentTheme, setCurrentTheme] = useState(createTheme())

  //value is the object that is passed into the Provider which allows anything in the value to be access
  //by the children of AlertProvider
  const value = {
    currentTheme,
    setCurrentTheme,
  }

  useEffect(() => {
    setCurrentTheme(createTheme({ ...getTheme(strippedDomain) }))
  }, [strippedDomain])

  /*********************************************************************************************** */
  /**Rendering */

  return (
    <CustomThemeContext.Provider value={value}>
      <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>
    </CustomThemeContext.Provider>
  )
}
